import { Box, Typography } from "@mui/material";
import React from "react";
import { ColorBox } from "./styles";

const LegendText = ({ color, text }) => {
  return (
    <Box display="flex" alignItems="center">
      <ColorBox color={color} />
      <Typography sx={{ marginLeft: 2 }}>{text}</Typography>
    </Box>
  );
};

export default LegendText;
